import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getMeetingsList(axiosPrivate, dateFrom, dateTo, phrase) {
	return axiosPrivate
		.get(`${apiURL}/meeting.json?from=${dateFrom}&to=${dateTo}${phrase ? `&phrase=${phrase}` : ""}`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addMeeting(axiosPrivate, navigate, data) {
	return axiosPrivate
		.post(`${apiURL}/meeting.json`, data)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Meeting added");
				navigate(`/meetings/${res.data.id}`, { replace: true });
			} else {
				toast.error("Could not add meeting. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function editMeeting(axiosPrivate, id, data, cb) {
	return axiosPrivate
		.put(`${apiURL}/meeting/${id}.json`, data)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Meeting updated");
				cb();
			} else {
				toast.error("Could not update meeting. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getMeeting(axiosPrivate, id) {
	return axiosPrivate
		.get(`${apiURL}/meeting/${id}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteMeeting(axiosPrivate, id, cb) {
	return axiosPrivate
		.delete(`${apiURL}/meeting/${id}.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Meeting deleted");
				cb();
			} else {
				toast.error("Could not delete meeting. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getMeetingPoints(axiosPrivate, meetingId) {
	return axiosPrivate
		.get(`${apiURL}/meeting/${meetingId}/agenda.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getPeople(axiosPrivate, phrase, meetingId) {
	return axiosPrivate
		.get(`${apiURL}/meeting/${meetingId}/possible-guest-user.json${phrase ? "?phrase=" + phrase : ""}`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUnits(axiosPrivate, phrase, meetingId) {
	return axiosPrivate
		.get(`${apiURL}/meeting/${meetingId}/possible-guest-organization-unit.json${phrase ? `?phrase=${phrase}` : ""}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUserUnitList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/user/organization-units.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				const resultData = res.data;
				const parsedData = [];

				for (const result of resultData) {
					parsedData.push(result.organizationUnit);
				}

				return parsedData;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addAgenda(axiosPrivate, meetingId, data, cb) {
	return axiosPrivate
		.put(`${apiURL}/meeting/${meetingId}/agenda.json`, data)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Agenda updated");
				cb();
			} else {
				toast.error("Could not update agenda. Please try again.");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAgenda(axiosPrivate, meetingId) {
	return axiosPrivate
		.get(`${apiURL}/meeting/${meetingId}/agenda.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUnitMeetings(axiosPrivate, organizationUnitId, dateFrom, dateTo) {
	return axiosPrivate
		.get(`${apiURL}/meeting/organization-unit/${organizationUnitId}.json?fromDate=${dateFrom}&toDate=${dateTo}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getDecisionMeetings(axiosPrivate, decisionId, dateFrom, dateTo) {
	return axiosPrivate
		.get(`${apiURL}/meeting/decision/${decisionId}.json?fromDate=${dateFrom}&toDate=${dateTo}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				return res.data;
			}
		})
		.catch((err) => {
			return err.response;
		});
}
